import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import "../../styles.css";
import axios from "axios";
import { useState, useEffect } from "react";

const columnHeaders = [
    { label: "Rank", name: "rank", width: '6%', align: 'center'},
    { label: "Username", name: "pu.login", width: '15%'},
    { label: "Email", name: "pu.email", width: '50%'},
];

const CreatorsTable = (props) => {
    const [isDragging, setDragging] = useState(null);
    const {
        creators,
        setCreators,
        paginated,
        pageItems,
        page,
        isLoading,
        total,
        orderBy,
        setPage,
        setOrderBy,
        handleActionTable,
    } = props;

    const [originalCreators, setOriginalCreators] = useState([])
    const [errors, setErrors] = useState([])

    useEffect(() => {
        setOriginalCreators(JSON.parse(JSON.stringify(creators)))
    }, [creators])

    const handleNextPage = () => {
        if (paginated.current_page < paginated.last_page)
            setPage(paginated.current_page + 1);
    };

    const handleLastPage = () => {
        setPage(paginated.last_page);
    };

    const handlePrevPage = () => {
        if (paginated.current_page > 1)
            setPage(paginated.current_page - 1);
    };

    const handleFirstPage = () => {
        setPage(1);
    };

    const PaginationContainer = () => {
        const isPrevDisabled = page > 1 ? false : true;
        const isNextDisabled = page < paginated.last_page ? false : true;
        return (
            <Pagination
                style={{ justifyContent: "flex-end", alignItems: "center" }}
            >
                <span className="mr-3">
                    {total} item{total > 1 ? "s" : ""}
                </span>
                <Pagination.First
                    disabled={isPrevDisabled}
                    className="mr-1"
                    onClick={handleFirstPage}
                />
                <Pagination.Prev
                    disabled={isPrevDisabled}
                    onClick={handlePrevPage}
                />
                <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
                    <div className="mr-1" style={{ width: 35 }}>
                        <input
                            type="text"
                            className="pagination-input"
                            onChange={(e) => setPage(e.target.value)}
                            value={page}
                        />
                    </div>
                    of {pageItems}
                </div>
                <Pagination.Next
                    disabled={isNextDisabled}
                    onClick={handleNextPage}
                />
                <Pagination.Last
                    disabled={isNextDisabled}
                    className="ml-1"
                    onClick={handleLastPage}
                />
            </Pagination>
        );
    };

    const ColumnContainer = () => {
        return (
            <tr>
                {columnHeaders.map((header, index) => {
                    return (
                        <th
                            className="border-top-0"
                            style={{ width: header.width, textAlign: header.align}}
                            key={index}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOrderBy(header.name, orderBy.order);
                                }}>
                                <span style={{ color: "black" }}>
                                    {header.label}
                                    {orderBy.header === header.name && (
                                        <FontAwesomeIcon
                                            className="ml-2"
                                            color="#0097FE"
                                            icon={[
                                                "fas",
                                                orderBy.order === "DESC"
                                                    ? "chevron-down"
                                                    : "chevron-up",
                                            ]}/>
                                    )}
                                </span>
                                
                            </a>
                        </th>
                    );
                })}
            </tr>
        );
    };

    const handleOrderBy = (header, order) => {
        order = order === "ASC" || orderBy.header != header ? "DESC" : "ASC";

        setOrderBy({
            ...orderBy,
            header: header,
            order: order,
        });
    };

    const handleDragEnd = (results) => {
        const { destination, source, type } = results;
        setDragging(null);
        // if no destination, don't do anything
        if (!destination) {
            return;
        }

        // if destination = source, don't do anything
        if (destination.droppableId === source.droppableId && destination.index === source.index ) {
            return;
        }

        if (type === "creator") {
            const newCollectionOrder = Array.from(creators);
            const selectedRow = newCollectionOrder.splice(source.index, 1)
            newCollectionOrder.splice(destination.index, 0, selectedRow[0])
            setCreators(newCollectionOrder);
            updateRanks(newCollectionOrder, destination, source);
            return;
        }
    }

    const updateRanks = (newCollectionOrder, destination, source) => {
        let creatorsToUpdate = [];
        let willUpdateRanks = false;

        // check current rank
        const pu1 = originalCreators[source.index]
        const pu2 = originalCreators[destination.index]
    
        newCollectionOrder.forEach((creator, index) => {
            // drag up
            if (creator.rank < pu1.rank && creator.rank >= pu2.rank) {
                creator.rank = creator.rank + 1
            } else if (creator.rank > pu1.rank && creator.rank <= pu2.rank) {
                creator.rank = creator.rank - 1
            }
            if (creator.pu_id == pu1.pu_id) {
                creator.rank = pu2.rank
            }

            creatorsToUpdate.push(creator);
        });

        setErrors([])
        // if(creatorsToUpdate.length > 0){
        axios.post("/api/administration/creator/update/ranks", {
            updateCreators: creatorsToUpdate,
        }).then((response) => {
            const data = response.data;
        }).catch((error) => {
            console.log(error.response)
            if (error.response.status === 422) {
                let tmp = []
                Object.keys(error.response.data.errors).forEach((key) => {
                    tmp.push(error.response.data.errors[key][0])
                });
                setErrors(tmp)
                setCreators(originalCreators)
            }
        })
    }

    return (
        <div className="w-100">
            <div className="alert alert-info px-4 py-2">
                - Double click to edit Creator ranking or click EDIT to search and edit the ranking.<br />
                - Drag and drop sorting is <strong>disabled</strong> when sorted by Username or Email
            </div>
            {
                errors.length > 0 && <div className="alert alert-danger px-4 py-2">
                    <ul class="mb-0 pl-3">
                    {errors.map((error, index) => <li key={index}>{error}</li>)}
                    </ul>
                </div>
            }
            <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="d-flex flex-row align-items-center justify-content-between w-100">
                    <div className="mb-3 d-flex flex-row align-items-center">
                        <Button
                            variant="primary"
                            className="mr-2"
                            style={{minWidth: '15%'}}
                            disabled={isLoading}
                            onClick={() => handleActionTable('add')}>
                            Add
                        </Button>

                        <Button
                            variant="primary"
                            className="mr-2"
                            style={{minWidth: '15%'}}
                            disabled={isLoading}
                            onClick={() => handleActionTable('edit-global')}>
                            Edit
                        </Button>
                    </div>

                    {paginated.total > 0 && (
                        <div className="text-right my-2 w-75">
                            {PaginationContainer()}
                        </div>
                    )}
                </div>
            </div>

            <DragDropContext onDragStart={(result) => setDragging(result.source.index)} onDragEnd={(results) => handleDragEnd(results)}>
                <div className="pu-table-container">
                    <Table size="sm" striped hover responsive className="mb-0">
                        <thead>
                            <ColumnContainer />
                        </thead>

                        <Droppable droppableId="all-creators" type="creator">
                            {(provided, snapshot) => (
                                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                    {creators.map((creator, index) => {
                                        return(
                                            <Draggable key={creator.id} draggableId={creator.id.toString()} index={index} isDragDisabled={orderBy.header != 'rank'}>
                                                {(provided, snapshot) => (
                                                    <tr
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef}
                                                        onDoubleClick={() => handleActionTable('edit', creator)}
                                                        className={`${isDragging === index ? 'draggable-container d-flex flex-row align-items-center' : ''} user-table-row`}>
                                                        <td className={`${isDragging === index ? 'text-light' : 'text-secondary'} d-flex flex-row align-items-center justify-content-center position-relative border-top-0`} style={{gap: 10}}>
                                                            <button className="edit-rank-btn border-0" onClick={() => handleActionTable('edit', creator)}>Edit</button>
                                                            {creator.rank}
                                                        </td>
                                                        <td className={`${isDragging === index ? 'text-light' : 'text-secondary'} border-top-0`}>
                                                            {creator.pu.login}
                                                        </td>
                                                        <td className={`${isDragging === index ? 'text-light' : 'text-secondary'} border-top-0`}>
                                                            {creator.pu.email}
                                                        </td>
                                                    </tr>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </tbody>
                            )}
                        </Droppable>


                        <tfoot>
                            <ColumnContainer />
                        </tfoot>
                    </Table>
                </div>
                {/* <div className="text-right my-3">
                    {PaginationContainer()}
                </div> */}
            </DragDropContext>
        </div>
    );
};

export default CreatorsTable;
